import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { AuthorizationWrapper } from 'components/wrappers/AuthorizationWrapper';
import { CurrencyDollarIcon } from '@heroicons/react/24/outline';
import ClipboardListIcon from 'components/v2/icons/ClipboardListIcon';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';
import { getIsNewFscFlow } from 'utils/FscSettingsApiUtils';
import UserCircleIcon from '../../v2/icons/UserCircleIcon';
import VerticalNav from '../../v2/navs/VerticalNav';
import CogIcon from '../../v2/icons/CogIcon';
import BellIcon from '../../v2/icons/BellIcon';
import SquaresPlusIcon from '../../v2/icons/SquarePlusIcon';
import ChatAltIcon from '../../v2/icons/ChatAltIcon';
import UserGroupIcon from '../../v2/icons/UserGroupIcon';
import SessionStore from '../../../stores/SessionStore';

const Sidebar = ({ userId, activePage, t }) => {
  const [isNewFscFlow, setIsNewFscFlow] = useState(null);

  function isActive(page) {
    return activePage === page;
  }

  useEffect(() => {
    (async () => {
      const isNewFscFlow = await getIsNewFscFlow();
      setIsNewFscFlow(isNewFscFlow);
    })();
  }, []);

  const profileActive = isActive('profile');
  const setttingsActive = isActive('yard-settings');
  const integrationsActive = isActive('integrations');
  const billingActive = isActive('billing');
  const teamActive = isActive('team');
  const ratesActive = isActive('rates');
  const accessorialRequestsActive = isActive('accessorial-requests');
  const stopDocumentRequirementsActive = isActive('stop-document-requirements');
  const referenceNumbersActive = isActive('reference-numbers');
  const notificationsActive = isActive('notifications');
  const activityActive = isActive('activity');
  return (
    <VerticalNav>
      <VerticalNav.NavItemWithIcon
        url={`/users/${userId}`}
        active={profileActive}
        title={titleize(t('PROFILE', { count: 1 }))}
      >
        {(iconClassName) => (
          <UserCircleIcon size="medium" className={iconClassName} />
        )}
      </VerticalNav.NavItemWithIcon>
      {/*
      <VerticalNav.NavItemWithIcon
        url={`/users/${userId}/account`}
        active={accountActive}
        title="Account"
      >
        {(iconClassName) => <CogIcon size="medium" className={iconClassName} />}
      </VerticalNav.NavItemWithIcon>

    */}
      <VerticalNav.NavItemWithIcon
        url={`/users/${userId}/settings/team`}
        active={teamActive}
        title={t('TEAM')}
      >
        {(iconClassName) => (
          <UserGroupIcon type="outline" className={iconClassName} />
        )}
      </VerticalNav.NavItemWithIcon>
      {SessionStore.isGodAdmin() && (
        <VerticalNav.NavItemWithIcon
          url={`/users/${userId}/settings/yard`}
          active={setttingsActive}
          title={t('YARD')}
        >
          {(iconClassName) => (
            <CogIcon size="medium" className={iconClassName} />
          )}
        </VerticalNav.NavItemWithIcon>
      )}
      <AuthorizationWrapper excludedRegions={[]}>
        <VerticalNav.NavItemWithIcon
          url={`/users/${userId}/settings/billing`}
          active={billingActive}
          title={t('BILLING', { count: 2 })}
        >
          {(iconClassName) => (
            <SquaresPlusIcon type="outline" className={iconClassName} />
          )}
        </VerticalNav.NavItemWithIcon>
      </AuthorizationWrapper>
      {isNewFscFlow && (
        <VerticalNav.NavItemWithIcon
          url={`/users/${userId}/settings/rates`}
          active={ratesActive}
          title={t('RATES_SETTINGS')}
        >
          {(iconClassName) => (
            <CurrencyDollarIcon type="outline" className={iconClassName} />
          )}
        </VerticalNav.NavItemWithIcon>
      )}
      {featureEnabled(CONFIGURED_FEATURES.SSR) && (
        <AuthorizationWrapper excludedRegions={[]}>
          <VerticalNav.NavItemWithIcon
            url={`/users/${userId}/settings/accessorial-requests`}
            active={accessorialRequestsActive}
            title={t('ACCESSORIAL_REQUESTS')}
          >
            {(iconClassName) => (
              <ClipboardListIcon type="outline" className={iconClassName} />
            )}
          </VerticalNav.NavItemWithIcon>
        </AuthorizationWrapper>
      )}
      {featureEnabled(CONFIGURED_FEATURES.SSR) && (
        <AuthorizationWrapper excludedRegions={[]}>
          <VerticalNav.NavItemWithIcon
            url={`/users/${userId}/settings/stop-document-requirements`}
            active={stopDocumentRequirementsActive}
            title={t('STOP_DOCUMENT_REQUIREMENTS')}
          >
            {(iconClassName) => (
              <ClipboardListIcon type="outline" className={iconClassName} />
            )}
          </VerticalNav.NavItemWithIcon>
        </AuthorizationWrapper>
      )}
      {featureEnabled(CONFIGURED_FEATURES.SSR) && (
        <AuthorizationWrapper excludedRegions={[]}>
          <VerticalNav.NavItemWithIcon
            url={`/users/${userId}/settings/reference-numbers`}
            active={referenceNumbersActive}
            title={t('REFERENCE_NUMBERS')}
          >
            {(iconClassName) => (
              <ClipboardListIcon type="outline" className={iconClassName} />
            )}
          </VerticalNav.NavItemWithIcon>
        </AuthorizationWrapper>
      )}
      <AuthorizationWrapper excludedRegions={[]}>
        <VerticalNav.NavItemWithIcon
          url={`/users/${userId}/settings/integrations`}
          active={integrationsActive}
          title={t('INTEGRATION', { count: 2 })}
        >
          {(iconClassName) => (
            <SquaresPlusIcon type="outline" className={iconClassName} />
          )}
        </VerticalNav.NavItemWithIcon>
      </AuthorizationWrapper>
      <VerticalNav.NavItemWithIcon
        url={`/users/${userId}/settings/notifications`}
        active={notificationsActive}
        title={titleize(t('NOTIFICATION', { count: 2 }))}
      >
        {(iconClassName) => (
          <BellIcon size="medium" className={iconClassName} />
        )}
      </VerticalNav.NavItemWithIcon>
      {/*
      <VerticalNav.NavItemWithIcon
        url={`/users/${userId}/settings/addresses`}
        active={contactsActive}
        title="Addresses"
      >
        {(iconClassName) => (
          <MapPinIcon size="medium" className={iconClassName} />
        )}
      </VerticalNav.NavItemWithIcon>
      <VerticalNav.NavItemWithIcon
        url={`/users/${userId}/contacts`}
        active={contactsActive}
        title="Contacts"
      >
        {(iconClassName) => (
          <UserGroupIcon type="outline" className={iconClassName} />
        )}
      </VerticalNav.NavItemWithIcon>
      */}
      <VerticalNav.NavItemWithIcon
        url={`/users/${userId}/activity`}
        active={activityActive}
        title={titleize(t('ACTIVITY'))}
      >
        {(iconClassName) => (
          <ChatAltIcon type="outline" className={iconClassName} />
        )}
      </VerticalNav.NavItemWithIcon>
    </VerticalNav>
  );
};

Sidebar.propTypes = {
  userId: PropTypes.string,
  activePage: PropTypes.string,
};

Sidebar.defaultProps = {
  activePage: 'profile',
};

export default withTranslation()(Sidebar);
